import { ADD_COMMENT_REPLY, EDIT_COMMENT_REPLY, FETCH_COMMENTS } from "../constants/comments";
import { Filter } from "../types";

export function fetchComments(doctorId: number, filters: Filter) {
  return {
    type: FETCH_COMMENTS,
    api: true,
    payload: {
      method: "GET",
      url: `/comments/${doctorId}`,
      params: filters,
    },
  };
}

export function addCommentReply(data: object) {
  return {
    type: ADD_COMMENT_REPLY,
    api: true,
    payload: {
      method: "POST",
      url: "/doctor/reply",
      data,
    },
  };
}

export function editCommentReply(replyId: number, body: string) {
  return {
    type: EDIT_COMMENT_REPLY,
    api: true,
    payload: {
      method: "PATCH",
      url: `/doctor/reply/${replyId}`,
      data: { body },
    },
    data: { replyId },
  };
}
